/**
 * locomotion.js
 * 2. VẬN ĐỘNG THỂ CHẤT & DI CHUYỂN
 */

function crawlPose(pose, time, _elapsed, anim) {
  // Bò bằng 4 chi thật sự (Quadrupedal crawl):
  const crawlCycle = time * 7.5;
  if (anim.parts.leftCalf) {
    // Bò quỳ bằng đầu gối (Kneeling quadrupedal crawl):
    // Đùi gập ~60°-80°, đầu gối gập vuông góc 95°-105° để bò bằng đầu gối thật sự!
    pose.rootY = -0.34 * (anim.basePelvisY / 0.65); // Hạ người theo tỉ lệ chiều dài chân (trẻ em chân ngắn hạ ít hơn)
    pose.torsoRotX = 1.05; // Thân nằm ngang song song sàn
    pose.headRotX = -0.75; // Ngẩng đầu nhìn phía trước

    // Chân so le bò bằng đầu gối
    pose.leftLegRotX = -0.7 + Math.sin(crawlCycle) * 0.38;
    pose.leftCalfRotX = 1.75 + Math.sin(crawlCycle) * 0.28; // Gối gập vuông góc tiếp đất!

    pose.rightLegRotX = -0.7 - Math.sin(crawlCycle) * 0.38;
    pose.rightCalfRotX = 1.75 - Math.sin(crawlCycle) * 0.28;

    // Tay so le chống đất với khuỷu tay gập (tay dài 0.70 nên vươn trước & gập sâu hơn để bàn tay chạm sàn)
    pose.leftArmRotX = -1.25 + Math.sin(crawlCycle) * 0.42;
    pose.leftForearmRotX = -0.85 - Math.sin(crawlCycle) * 0.35; // Cùi chỏ gập sâu khi cánh tay vung xuống để bàn tay không xuyên sàn
    pose.leftArmRotZ = -0.15;

    pose.rightArmRotX = -1.25 - Math.sin(crawlCycle) * 0.42;
    pose.rightForearmRotX = -0.85 + Math.sin(crawlCycle) * 0.35;
    pose.rightArmRotZ = 0.15;

    pose.pelvisRotZ = Math.sin(crawlCycle) * 0.08;
    pose.rootY += Math.sin(crawlCycle * 2) * 0.012;
  } else {
    // Fallback cho mô hình khối thẳng Classic cũ
    pose.rootY = -0.46;
    pose.torsoRotX = 1.05;
    pose.headRotX = -0.85;
    pose.leftArmRotX = -1.25 + Math.sin(crawlCycle) * 0.5;
    pose.rightArmRotX = -1.25 - Math.sin(crawlCycle) * 0.5;
    pose.leftArmRotZ = -0.15;
    pose.rightArmRotZ = 0.15;
    pose.leftLegRotX = -0.85 - Math.sin(crawlCycle) * 0.45;
    pose.rightLegRotX = -0.85 + Math.sin(crawlCycle) * 0.45;
    pose.pelvisRotZ = Math.sin(crawlCycle) * 0.08;
    pose.rootY += Math.sin(crawlCycle * 2) * 0.015;
  }
}

export const LOCOMOTION_POSES = {
  walk: (pose, time, _elapsed, anim) => {
    const cycle = time * anim.walkSpeed;
    const leftPhase = Math.sin(cycle);

    pose.leftLegRotX = -leftPhase * 0.52;
    pose.rightLegRotX = leftPhase * 0.52;

    // Đi bộ phong cách Voxel kinh điển: Chân tay vung thẳng nguyên khối
    pose.leftArmRotX = leftPhase * 0.45;
    pose.rightArmRotX = -leftPhase * 0.45;
    pose.leftArmRotZ = -0.08;
    pose.rightArmRotZ = 0.08;
    pose.rootY = Math.abs(Math.sin(cycle)) * 0.04;
    pose.torsoRotY = Math.sin(cycle) * 0.06;
    pose.headRotY = -Math.sin(cycle) * 0.03;
  },

  run: (pose, time) => {
    // Chạy nhanh Voxel truyền thống: Chân tay đánh thẳng dứt khoát biên độ mạnh mẽ
    const runCycle = time * 12.5;
    const leftPhase = -Math.sin(runCycle);
    const rightPhase = Math.sin(runCycle);

    pose.torsoRotX = 0.28; // Thân người ngả về phía trước
    pose.headRotX = -0.15; // Đầu ngẩng nhìn thẳng
    pose.leftLegRotX = leftPhase * 0.95;
    pose.rightLegRotX = rightPhase * 0.95;

    // Hai tay đánh nhịp thẳng dứt khoát
    pose.leftArmRotX = -leftPhase * 0.85;
    pose.rightArmRotX = -rightPhase * 0.85;
    pose.leftArmRotZ = -0.15;
    pose.rightArmRotZ = 0.15;

    pose.rootY = Math.abs(Math.sin(runCycle)) * 0.09;
    pose.torsoRotY = Math.sin(runCycle) * 0.12;
  },

  jump: (pose, _time, elapsed) => {
    // Nhảy bật cao (One-shot: Khụy chân gập gối -> Bật cao duỗi chân -> Tiếp đất gập gối giảm chấn)
    const t = Math.min(elapsed, 1.1);
    if (t < 0.22) {
      // Pha 1: Khụy gối lấy đà
      const prep = t / 0.22;
      pose.rootY = -prep * 0.14;
      pose.leftLegRotX = -prep * 0.4;
      pose.rightLegRotX = -prep * 0.4;
      pose.leftCalfRotX = prep * 0.95; // Đầu gối gập lấy đà!
      pose.rightCalfRotX = prep * 0.95;
      pose.torsoRotX = prep * 0.25;
      pose.leftArmRotX = prep * 0.35;
      pose.rightArmRotX = prep * 0.35;
      pose.leftForearmRotX = -prep * 0.3;
      pose.rightForearmRotX = -prep * 0.3;
    } else if (t < 0.75) {
      // Pha 2: Bật vọt lên không trung
      const jumpPhase = (t - 0.22) / 0.53;
      pose.rootY = Math.sin(jumpPhase * Math.PI) * 0.48; // Đỉnh nhảy 0.48m
      pose.leftArmRotX = -Math.PI * 0.85;
      pose.rightArmRotX = -Math.PI * 0.85;
      pose.leftForearmRotX = -0.45;
      pose.rightForearmRotX = -0.45;
      pose.leftArmRotZ = -0.25;
      pose.rightArmRotZ = 0.25;
      pose.leftLegRotX = 0.12;
      pose.rightLegRotX = 0.12;
      pose.leftCalfRotX = 0.2; // Duỗi chân
      pose.rightCalfRotX = 0.2;
      pose.torsoRotX = -0.08;
    } else {
      // Pha 3: Tiếp đất khụy gối giảm chấn rồi đứng thẳng
      const landPhase = (t - 0.75) / 0.35;
      const damp = Math.sin((1 - landPhase) * Math.PI * 0.5);
      pose.rootY = -damp * 0.08;
      pose.leftLegRotX = -damp * 0.25;
      pose.rightLegRotX = -damp * 0.25;
      pose.leftCalfRotX = damp * 0.75; // Đầu gối gập giảm chấn!
      pose.rightCalfRotX = damp * 0.75;
      pose.leftArmRotX = -damp * 0.2;
      pose.rightArmRotX = -damp * 0.2;
    }
  },

  hop_one_leg: (pose, time) => {
    // Nhảy lò cò (Loop: Gập gối chân trái co ra sau, chân phải nhún nhảy liên tục)
    const hopCycle = time * 9.5;
    pose.leftLegRotX = 0.45;
    pose.leftCalfRotX = 1.85; // Chân trái gập gối co hẳn ra phía sau
    pose.rightLegRotX = -0.08 + Math.sin(hopCycle) * 0.15; // Chân phải nhún
    pose.rightCalfRotX = Math.abs(Math.sin(hopCycle)) * 0.35;
    pose.rootY = Math.abs(Math.sin(hopCycle)) * 0.075;
    // Hai tay giang rộng lắc lư giữ thăng bằng
    pose.leftArmRotZ = -0.55 + Math.sin(hopCycle * 0.5) * 0.18;
    pose.rightArmRotZ = 0.55 - Math.sin(hopCycle * 0.5) * 0.18;
    pose.leftArmRotX = -0.2;
    pose.rightArmRotX = -0.2;
    pose.leftForearmRotX = -0.45;
    pose.rightForearmRotX = -0.45;
    pose.torsoRotZ = 0.08 + Math.sin(hopCycle * 0.5) * 0.06;
  },

  crawl: crawlPose,
  crouch_low: crawlPose,

  sit_ground: (pose, time, elapsed, anim) => {
    // Ngồi bệt xuống đất (One-shot: Hạ người từ từ -> Ngồi bệt mông chạm sàn, hai đầu gối gập tự nhiên)
    const t = Math.min(elapsed, 1.4);
    const groundDrop = -(anim.basePelvisY - 0.08); // Mông tiếp sàn
    if (t < 0.55) {
      const p = t / 0.55;
      pose.rootY = p * groundDrop;
      pose.leftLegRotX = -p * 1.45;
      pose.rightLegRotX = -p * 1.45;
      pose.leftCalfRotX = p * 1.25; // Gối gập khi ngồi bệt
      pose.rightCalfRotX = p * 1.25;
      pose.leftLegRotZ = -p * 0.14;
      pose.rightLegRotZ = p * 0.14;
      pose.leftArmRotX = p * 0.12;
      pose.rightArmRotX = p * 0.12;
      pose.leftForearmRotX = -p * 0.35;
      pose.rightForearmRotX = -p * 0.35;
      pose.leftArmRotZ = -p * 0.35;
      pose.rightArmRotZ = p * 0.35;
      pose.torsoRotX = -p * 0.08;
    } else {
      // Ngồi bệt thư thái, ngực thở nhẹ
      pose.rootY = groundDrop + Math.sin(time * 2.0) * 0.005;
      pose.leftLegRotX = -1.45;
      pose.rightLegRotX = -1.45;
      pose.leftCalfRotX = 1.25; // Gối gập tự nhiên
      pose.rightCalfRotX = 1.25;
      pose.leftLegRotZ = -0.14;
      pose.rightLegRotZ = 0.14;
      pose.torsoRotX = -0.08;
      pose.headRotX = -0.05;
      pose.leftArmRotX = 0.12;
      pose.rightArmRotX = 0.12;
      pose.leftForearmRotX = -0.35;
      pose.rightForearmRotX = -0.35;
      pose.leftArmRotZ = -0.35;
      pose.rightArmRotZ = 0.35;
    }
  },

  stand_up: (pose, _time, elapsed, anim) => {
    // Đứng dậy (One-shot: Từ tư thế thấp/ngồi bệt -> Chống tay đẩy hông -> Duỗi gối đứng thẳng)
    const t = Math.min(elapsed, 1.4);
    const groundDrop = -(anim.basePelvisY - 0.08);
    if (t < 0.4) {
      // Pha 1: Chống tay đẩy người, kéo chân
      const p = t / 0.4;
      pose.rootY = groundDrop + p * (-groundDrop * 0.5);
      pose.leftLegRotX = -1.45 * (1 - p * 0.5);
      pose.rightLegRotX = -1.45 * (1 - p * 0.5);
      pose.leftCalfRotX = 1.25 * (1 - p * 0.3);
      pose.rightCalfRotX = 1.25 * (1 - p * 0.3);
      pose.torsoRotX = 0.35 * p; // Chúi người lấy đà
      pose.leftArmRotX = -0.45;
      pose.rightArmRotX = -0.45;
      pose.leftForearmRotX = -0.45;
      pose.rightForearmRotX = -0.45;
    } else if (t < 0.95) {
      // Pha 2: Đẩy chân đứng thẳng dậy
      const p = (t - 0.4) / 0.55;
      pose.rootY = groundDrop * 0.5 * (1 - p);
      pose.leftLegRotX = -0.75 * (1 - p);
      pose.rightLegRotX = -0.75 * (1 - p);
      pose.leftCalfRotX = 0.85 * (1 - p);
      pose.rightCalfRotX = 0.85 * (1 - p);
      pose.torsoRotX = 0.35 * (1 - p);
      pose.leftArmRotX = -0.45 * (1 - p);
      pose.rightArmRotX = -0.45 * (1 - p);
      pose.leftForearmRotX = -0.45 * (1 - p);
      pose.rightForearmRotX = -0.45 * (1 - p);
    } else {
      // Pha 3: Đứng thẳng hoàn toàn, phủi nhẹ
      const p = (t - 0.95) / 0.45;
      pose.rootY = 0;
      pose.leftArmRotX = Math.sin(p * Math.PI) * 0.15;
      pose.rightArmRotX = Math.sin(p * Math.PI) * 0.15;
      pose.headRotX = -0.08;
    }
  }
};
